import * as React from "react";

export const DrawerFragment_GiftcardHelp_Content: React.FunctionComponent =
  () => {
    return (
      <section className="bbnt-checkout-2022-giftcard-help-drawer-content">
        <h1>{`Gift card issues?`}</h1>

        <div className="giftcard-help">
          <p>{`If you are having problems applying your gift card, check the following:`}</p>
          <ol>
            <li>{`Make sure that you have entered the correct gift card number and PIN, with no spaces.`}</li>
            <li>{`Check the expiry date on your gift card or PDF and ensure that it has not expired.`}</li>
            <li>
              <span>{`Confirm that you have balance remaining in your gift card (you can check your balance from your account or by visiting our`}</span>
              <a href="/gift-cards">{`gift cards page`}</a>
              <span>{`).`}</span>
            </li>
            <li>{`If you have a gift card in your cart, please remove it from your order as you cannot use a gift card to redeem another one.`}</li>
          </ol>
          <div className="need-more-help">
            <span>{`If you are still experiencing issues,`}&nbsp;</span>
            <a
              target="_blank"
              href="https://support.bedbathntable.com.au/support/tickets/new"
            >{`Contact our customer support team.`}</a>
          </div>
        </div>
      </section>
    );
  };
